import * as React from "react";
import { Box } from "@mui/material";

interface ScreenLayoutProps {
  children: React.ReactNode;
  padding?: "none" | "small" | "medium" | "large";
}

export default function ScreenLayout({ children, padding = "medium" }: ScreenLayoutProps) {
  const getPadding = () => {
    switch (padding) {
      case "none": return 0;
      case "small": return "1rem";
      case "large": return "2rem";
      default: return "1.5rem";
    }
  };

  return (
    <Box sx={{ pt: getPadding(), px: getPadding(), pb: getPadding() }}>
      {children}
    </Box>
  );
}
